import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['LocationMaster'],
});
export const locationMasterApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllLocationMasters: builder.query({
      query: () => `location_masters/`,
      keepUnusedDataFor: 0,
      providesTags: ['LocationMaster'],
    }),
    findAllLocationMastersOriginalETA: builder.query({
      query: () =>
        `location_masters/?location_type__code=001&location_type__code=002&location_type__code=003&location_type__code=004`,
      keepUnusedDataFor: 0,
      providesTags: ['LocationMaster'],
    }),
    findAllLocationMastersByYard: builder.query({
      query: () => `location_masters/?location_type__code=004`,
      keepUnusedDataFor: 0,
      providesTags: ['LocationMaster'],
    }),
    findLocationMasterById: builder.query({
      query: (id) => `location_masters/${id}/`,
      keepUnusedDataFor: 0, // No cache
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'LocationMaster', id: result.id }]
          : ['LocationMaster'];
      },
    }),
    findAllLocationMastersByType: builder.query({
      query: (name) => ({
        url: `location_masters/?location_type__name=${name}`,
        method: 'GET',
      }),
      providesTags: ['LocationMaster'],
    }),
    createLocationMaster: builder.mutation({
      query: (locationMaster) => ({
        url: `location_masters/`,
        method: 'POST',
        body: locationMaster,
      }),
      // invalidatesTags: ['LocationMaster'],
    }),
    updateLocationMaster: builder.mutation({
      query: (locationMaster) => ({
        url: `location_masters/${locationMaster.id}/`,
        method: 'PATCH',
        body: locationMaster,
      }),
      // invalidatesTags: ['LocationMaster'],
    }),
    deleteLocationMaster: builder.mutation({
      query: (locationMaster) => ({
        url: `location_masters/${locationMaster.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['LocationMaster'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllLocationMastersOriginalETAQuery,
  useFindAllLocationMastersQuery,
  useFindAllLocationMastersByYardQuery,
  useFindLocationMasterByIdQuery,
  useFindAllLocationMastersByTypeQuery,
  useCreateLocationMasterMutation,
  useUpdateLocationMasterMutation,
  useDeleteLocationMasterMutation,
} = locationMasterApi;
